<template>
    <div>
      <loadingcomp
        v-bind:mesaj="loadingmesaj"
        v-model="loadingvmodel"
      ></loadingcomp>
      <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
  
      <v-dialog
        persistent
        max-width="850px"
        v-model="dialog"
        @keydown.esc="cancel"
      >
        <v-card>
          <v-card-title style="background-color: #01579b">
            <span class="headline white--text">Hesap Bakiyelerini Aktarmak İçin Otomatik Fiş Oluştur</span>
          </v-card-title>
          <v-card-text class="pa-4">
            <v-layout wrap>
              <v-flex xs12 sm12 md12>
                <v-form ref="referansbirlestir">
                  <v-flex xs12 sm12 md12>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <blockquote>
                         İşleme Devam Edilmesini İstiyor musunuz..?
                         </blockquote>
                       
                      </v-flex>
                     
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <blockquote style="color: red;">
                         Fiş Numarası Belirtilen Tarihin En Sonuna Atılacak Şekilde Verilecektir. 
                         </blockquote>
                        
                      </v-flex>
                     
                    </v-layout>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="FirstAccountingCode"
                    :controlValue="FirstAccountingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    text='Kaynak Hesap Kodu Başlangıç'
                    @validateCheck="checkAccoutingValidate()"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="LastAccountingCode"
                    :controlValue="LastAccountingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    text='Kaynak Hesap Kodu Bitiş'
                   
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <catimuhasebekodu
                    v-model="ReflectionAccountingCode"
                    :controlValue="ReflectionAccountingCode"
                    :companyID="credentials.MuhasebeSirketNo"
                    text="Virman Yapılacak Hesap Kodu"
                    :Coper="false"
                  >
                  </catimuhasebekodu>
                </v-flex>
                <v-flex xs12 sm12 md12>
                  <v-text-field
                  label="Fiş Açıklaması"
                  v-model="RecieptTitle"
                ></v-text-field>
                </v-flex>
                 <v-flex xs12 sm12 md12>
                  <v-select
                  label="Bakiye Türü"
                  v-model="BakiyeTuru"
                  :items="BakiyeTurleri"
                   item-text="adi"
                    item-value="id"
                ></v-select>
                </v-flex>
                 <v-flex xs12 sm12 md12>
                        <tarihcomp
                          etiket="Başlangıç Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="DateStart"
                        >
                        </tarihcomp>
                      </v-flex>
                       <v-flex xs12 sm12 md12>
                       <tarihcomp
                          etiket="Bitiş Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="DateEnd"
                        >
                        </tarihcomp>
                      </v-flex>
                       <v-flex xs12 sm12 md12>
                        <tarihcomp
                          etiket="Fiş Tarihi"
                          v-bind:detaygizle="true"
                          v-bind:defaultvalue="'no'"
                          v-model="RecieptDate"
                        >
                        </tarihcomp>
                      </v-flex>
                    
             
              </v-layout>
                   
                  </v-flex>
                </v-form>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions class="pt-0">
            <v-spacer></v-spacer>
            <v-btn color="primary darken-1" text @click.native="close()">{{
              $t("cancel_button")
            }}</v-btn>
            <v-btn color="primary darken-1" text @click.native="makeChange()">
              {{ 'Oluştur' }}
            </v-btn>
          
          </v-card-actions>
        </v-card>
      </v-dialog>
  
     
    </div>
  </template>
  
  <script>
 
  import auth from "../../../../../api/auth";
  import loadingcomp from "@/components/app/customcomp/loadingcomp";
  import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
  import catimuhasebekodu from "../../comp/catimuhasebekodu.vue";
 import tarihcomp from "@/components/app/customcomp/tarihim";
  export default {
    data() {
      return {
        FirstAccountingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      LastAccountingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
      ReflectionAccountingCode: {
        CodeID: 0,
        CompanyID: 0,
        Code: null,
        CodeName: null,
        Text: null,
      },
        DateStart:null,
        DateEnd:null,
        RecieptDate:null,
        RecieptTitle:null,
        BakiyeTurleri:[
          {
            adi:'Alacak',
            id:0
          },
           {
            adi:'Borç',
            id:1
          }

        ],
        BakiyeTuru:0,
        dovizsayristir:0,
        seciliCariFirma:null,
        seciliMuhasebeFirma:null,
        dialog: false,
        credentials: JSON.parse(window.localStorage.getItem("credentials")),
        loadingvmodel: false,
        text1: null,
        snackbar: false,
        loadingmesaj: "Fiş İşlemi"
      };
    },
    components: {
      catimuhasebekodu,
      loadingcomp,
      snackbarcomp,
      tarihcomp
    },
    methods: {
      checkAccoutingValidate()
      {

      },
        close()
        {
           this.dialog=false;
        },
      makeChange() {
       
        this.loadingvmodel = true
        var CreditBalance=false;
        if (this.BakiyeTuru==0){
          CreditBalance=true;
        }
        let Params = {
          WithCurrency :this.dovizsayristir,
          CompanyID : this.credentials.MuhasebeSirketNo,
          UserID:this.credentials.UserID,
          FirstAccountingCode:this.FirstAccountingCode.Code,
          LastAccountingCode:this.LastAccountingCode.Code,
          AdvanceAccountingCode:this.ReflectionAccountingCode.Code,
          RecieptTitle:this.RecieptTitle,
          DateStart:this.DateStart,
          DateEnd:this.DateEnd,
          RecieptDate:this.RecieptDate,
          CreditBalance:CreditBalance
      };
          this.$http.post(auth.API_URL + 'api/AccountingParameters/MoveBalancesToAdvanceAccount', Params, {
            headers: {
              'Authorization': 'Bearer ' + auth.getAuthHeader()
            }
          }).then((response) => {
  
            this.loadingvmodel = false
            this.text1 =  response.body.ResponseMessage;
            this.snackbar =true;
  
          }, (response) => {
            if (response.status === 0) {
              this.text1 = 'Service- MoveBalancesToAdvanceAccount'
              this.snackbar =true;
              this.loadingvmodel = false
            } else {
              this.text1 = 'Service- MoveBalancesToAdvanceAccount'
              this.snackbar =true;
              this.loadingvmodel = false
            }
          })
        
         
          this.controlDialog = false;
          this.dialog=false;
      },
      open() {
        this.dialog = true;
      },
     
    },
  };
  </script>
  
  <style>
  </style>
  